<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr.courseScenarioExercise">
        <div class="grid-content">
          <div class="title">变更前</div>
          <div class="item">问题内容：{{form.beforeStr.courseScenarioExercise.question_content}}</div>
          <div class="item">图片：
            <div v-if="form.beforeStr.courseScenarioExercise.img_url">
              <el-image style="width: 50px; height: 50px" v-for="(item,index) in  form.beforeStr.courseScenarioExercise.img_url.split(',')" :key="index" :src="item" :preview-src-list="[item]"></el-image>
            </div>

          </div>
          <div class="item">状态：{{form.beforeStr.courseScenarioExercise.state?'启用':'禁用'}}</div>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr.courseScenarioExercise">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <div class="item">问题内容：{{form.afterStr.courseScenarioExercise.question_content}}</div>
          <div class="item">图片：
            <div v-if="form.afterStr.courseScenarioExercise.img_url">
              <el-image style="width: 50px; height: 50px" v-for="(item,index) in  form.afterStr.courseScenarioExercise.img_url.split(',')" :key="index" :src="item" :preview-src-list="[item]"></el-image>
            </div>

          </div>
          <div class="item">状态：{{form.afterStr.courseScenarioExercise.state?'启用':'禁用'}}</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;

      })
    }
  }

}
</script>

<style lang="scss" scoped>
</style>
